import React from 'react'
import ReactDOM from 'react-dom'

const Payment = ({ payment, handleChangePayment, data }) => {
    return <div className={ `happy-order__payments-item happy-order__payments-item_${ payment.CODE }${ data.payments.id === payment.ID ? ' happy-order__payments-item_active' : '' }` } onClick={ handleChangePayment.bind(this, payment) }>
        { payment.NAME }
    </div>
}

export default Payment